import {ProfileInjury} from '../resources/ProfileInjury';
import {DomainEvent} from './DomainEvent';

export class ProfileInjured extends DomainEvent<ProfileInjury> {}
